module.exports = __webpack_public_path__ + "static/media/3.589cf5a1.png";